import React from "react";
import "./css/checkout.scss";

import {
  basic_monthly,
  basic_yearly
} from "../constants/subscription_products";
import StripeCardCheckout from "../components/stripe/stripe_card_checkout";
import ErrorMessages from "../components/ui/error_messages";

// Checkout page that is meant to be a full page content in other pages.
export default function Checkout({
  onBeforeCreatePaymentMethod,
  onSubmit,
  product,
  setProduct,
  paymentErrors,
  setPaymentErrors,
  paymentName,
  setPaymentName,
  paymentEmail,
  setPaymentEmail,
  paymentPhone,
  setPaymentPhone,
  promoCode,
  setPromoCode,
  profile
}) {
  return (
    <div className="checkout">
      <ErrorMessages messages={paymentErrors} />
      <div className="flex">
        <div className="half-width">
          <div className="title">Payment Plans</div>
          <div className="plan-title">
            Basic Professional Plans
          </div>
          <div className="plan-price">
            <input
              type="radio"
              name="products"
              id="basic-monthly"
              checked={product === basic_monthly}
              value={basic_monthly}
              onChange={e => setProduct(e.target.value)}
            />
            <label htmlFor="basic-monthly">Monthly $25.00</label>
          </div>
          <div className="plan-price">
            <input
              type="radio"
              name="products"
              id="basic-yearly"
              checked={product === basic_yearly}
              value={basic_yearly}
              onChange={e => setProduct(e.target.value)}
            />
            <label htmlFor="basic-yearly">
              Annual $275.00
              <br />
              With the Annual Plan, you receive 1 month Free.
            </label>
          </div>
        </div>
        <div className="half-width">
          <div className="title">Payment</div>
          <StripeCardCheckout
            onBeforeCreatePaymentMethod={onBeforeCreatePaymentMethod}
            paymentName={paymentName}
            setPaymentName={setPaymentName}
            paymentEmail={paymentEmail}
            setPaymentEmail={setPaymentEmail}
            paymentPhone={paymentPhone}
            setPaymentPhone={setPaymentPhone}
            onSubmit={onSubmit}
            onError={error => setPaymentErrors([error.message])}
            promoCode={promoCode}
            setPromoCode={setPromoCode}
            profile={profile}
          />
        </div>
      </div>
    </div>
  );
}
